/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { TemplateCellModel } from "./TemplateCellModel";
import { CellModel } from "./CellModel";
import { markType } from "igniteui-react-core";
import { TemplateHeaderCellModelExport } from "./TemplateHeaderCellModelExport";
/**
 * @hidden
 */
var TemplateHeaderCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TemplateHeaderCellModel, _super);
    function TemplateHeaderCellModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.kj = false;
        return _this;
    }
    Object.defineProperty(TemplateHeaderCellModel.prototype, "kk", {
        get: function () {
            return this.kj;
        },
        set: function (a) {
            var b = this.kj;
            this.kj = a;
            if (this.kj != b) {
                this.jd("IsFilterUIVisible", TemplateHeaderCellModel.kl, b, this.kj);
            }
        },
        enumerable: true,
        configurable: true
    });
    TemplateHeaderCellModel.prototype.jl = function (a, b) {
        _super.prototype.jl.call(this, a, b);
        if (a == "IsFilterUIVisible") {
            this.kk = b;
        }
    };
    TemplateHeaderCellModel.prototype.gg = function (a) {
        if (a == "IsFilterUIVisible") {
            return this.kk;
        }
        return _super.prototype.gg.call(this, a);
    };
    TemplateHeaderCellModel.prototype.b = function (a) {
        if (a == null) {
            a = new TemplateHeaderCellModelExport();
        }
        a = _super.prototype.b.call(this, a);
        var b = a;
        b.ae = this.kh;
        return b;
    };
    TemplateHeaderCellModel.$t = markType(TemplateHeaderCellModel, 'TemplateHeaderCellModel', TemplateCellModel.$);
    TemplateHeaderCellModel.kl = CellModel.eu("IsFilterUIVisible");
    return TemplateHeaderCellModel;
}(TemplateCellModel));
export { TemplateHeaderCellModel };
//# sourceMappingURL=TemplateHeaderCellModel.js.map
